import { useAuthContext } from "hooks";

import { MFADisabledState, MFAEnabledState, MFAReadyState } from "./components";

export function MFASetupSection() {
  const { user } = useAuthContext();

  if (!user) return null;

  const hasVerifiedPhone = user.phone_number_verified_at !== null;
  const hasMfa = user.has_mfa_enabled;

  if (hasMfa && user.phone_number !== null) {
    return <MFAEnabledState phoneNumber={user.phone_number} />;
  }

  if (hasVerifiedPhone && user.phone_number !== null) {
    return <MFAReadyState phoneNumber={user.phone_number} />;
  }

  return <MFADisabledState />;
}
